const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

export const columns = [
    {
        dataField: 'name',
        text: 'Report Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'description',
        text: 'Report Description',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'reportCategoryName',
        text: 'Report Category',
        sort: true,
        headerStyle: headerStyle
    }
];

export const sorting = [{
    dataField: 'name',
    order: 'asc'
}];